export const LondonDynamicsImageRendering = "LondonDynamics";